const shopperPiiDtmMapper = require('../../../auth/shopper/analytics/shopper-profile-pii-analytics-dtm-mapper');

const analyticsConfig = ($window, bootstrap) => {

    // Google Analytics datalayer.
    $window.dataLayer = $window.dataLayer || [];

    // Adobe Analytics datalayer.
    $window.digitalData = $window.digitalData || {};

    if (bootstrap) {
        const shopper = bootstrap.getBootstrappedData(bootstrap.bootstrapped.Shopper);

        if (shopper) {
            $window.digitalData.user = shopperPiiDtmMapper({ shopperDetails: shopper }).user;

            $window.digitalData.page = {
                pageInfo: {
                    destinationUrl: $window.location.href,
                },
            };
        }
    }
};

module.exports = analyticsConfig;



// WEBPACK FOOTER //
// ./src/olycommon/analytics/analytics/analytics-config.js